export * from './tag.factory';
export * from './tag.response';
export * from './tag.response.mocks';
//# sourceMappingURL=index.js.map